module.exports = __webpack_public_path__ + "static/media/tbilisi3.158e9129.jpg";